import {createUseStyles} from 'react-jss'

export default createUseStyles({
  btn: {
    width: '100%',
    marginTop: 20,
    height: 40,
    border: 'none',
    backgroundColor: '#004f9f',
    cursor: 'pointer',
    borderRadius: 5,
    color: 'white',
    fontWeight: 'bold',
    boxShadow: '0 3px 10px rgba(0,0,0,0.7)',
    outline: 'none',
    '&:active': {
      boxShadow: '0 3px 10px rgba(0,0,0,0.5)',
      transform: 'scale(0.99)'
    },
    '&:disabled': {
      opacity: 0.8,
      backgroundColor:'rgba(0,0,0,0.3)'
    }
  },

})